import { useUrlQueryState } from '~/shared/hooks';

export default function usePaging() {
    const [queryState, setQueryState] = useUrlQueryState();
    const page = queryState?.page ? Number(queryState?.page) : 1;

    const setPage = (page: number) => {
        setQueryState('page', [String(page)]);
    };

    return [page, setPage] as const;
}
